<template>
  <li class="dropdown_menu" :class="mainExamListCssObj">
    <a v-b-toggle.membersCollapse @click.prevent="toggleCollapse">
      <b-icon-people-fill class="mr-1"></b-icon-people-fill>
      <span class="link-title menu_hide">ผู้เรียน</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="membersCollapse" :visible="false" accordion="accordion">
      <main-exam-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainExamCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import AuthMixin from "@/mixins/auth-mixin.js";
import CompanySideBars from "../CompanySidebarSwitch";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainExamCollapseMenu,
  },
  mixins: [AuthMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
      comId: localStorage.getItem("ComId"),
      memberId: JSON.parse(localStorage.getItem("user")).id,
    };
  },
  computed: {
    mainExamListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  async mounted() {
    if (checkSubMenuAccess({ menu: "user-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการผู้เรียน",
        to: {
          name: "member.index",
        },
      });
    }
    if (checkSubMenuAccess({ menu: "user-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการผู้สอน",
        to: {
          name: "instructor.index",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "user-group-mgmt" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "จัดการกลุ่มผู้เรียน",
        to: {
          name: "group.index",
        },
      });
    }
    if (checkSubMenuAccess({ menu: "enroll-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "ลงทะเบียนเรียน",
        to: { name: "course.enroll.index" },
      });
    }
    if (checkSubMenuAccess({ menu: "admin-mgmt" }, this.getCurrentUser())) {
      this.collapseList.push({
        title: "จัดการผู้ใช้งาน",
        to: {
          name: [1000001, 1000002, 1000003].includes(parseInt(this.comId)) ? "members.wannasorn-role" : "members.role",
        },
      });
    }
    if (
      checkSubMenuAccess({ menu: "abnormal-usage-log" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "ตรวจสอบการเรียนผิดปกติ",
        to: {
          name: "members.abnormal-usage",
        },
      });
    }
    if (
      checkSubMenuAccess(
        { menu: "member-identity-verification" },
        this.getCurrentUser(),
      )
    ) {
      this.collapseList.push({
        title: "ยืนยันตัวตนสมาชิก",
        to: {
          name: "member.identity-verification",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "face-verify-overview" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "คำขอลงทะเบียนใบหน้า",
        to: {
          name: "face.verify.overview",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "member-face-registration-verification" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "ตรวจสอบใบหน้าลงทะเบียน",
        to: {
          name: "face.verify.overview2",
        },
      });
    }
    if (
      await checkSubMenuAccess(
        { menu: "member-face-learning-verification" },
        this.getCurrentUser()
      )
    ) {
      this.collapseList.push({
        title: "การตรวจสอบใบหน้า",
        to: {
          name: "members.face-verification.index",
        },
      });
    }
  },
  methods: {
    ...CompanySideBars,
    toggleCollapse() {},
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
